import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `CopiaSeguridad/obtenerProgramacionCopiaSeguridad`, method: 'GET', body: null, token: token})
}